module.exports = __webpack_public_path__ + "img/1536999174.c8fa72b9.jpg";